import { DocumentService } from './DocumentService';
import { exportDocumentToPdf, stripExportOmitFromHtml } from './pdfExportService';
import { Toast } from '../components/shared/Toast';
import { shouldApplyExportWatermark } from '../utils/exportWatermark';
import { getDefaultExportConfig, resolveRomanNumeralFrontPages } from '../utils/pdfExportUtils';

function shouldForceSectionPageBreak(documentType) {
	const n = (documentType || '').toLowerCase();
	if (/dissertation|master'?s\s*thesis|masters\s*thesis/.test(n)) return true;
	if ((/professional|manuscript/.test(n)) && (/paper|academic|manuscript/.test(n))) return true;
	return false;
}

function fileContentToHtml(fileContent, documentType = '') {
	if (!fileContent) return '<p></p>';
	const parts = [];
	const safe = (html) => (typeof html === 'string' ? html : '');
	const forceBreak = shouldForceSectionPageBreak(documentType);
	let isFirst = true;

	(fileContent.categories || []).forEach((cat) => {
		(cat.sections || []).forEach((sec) => {
			if (sec.isVisible === false) return;
			if (sec.optional !== false && sec.optional !== undefined) return;

			const pageBreakClass = !isFirst && forceBreak ? 'page-break-before' : '';
			isFirst = false;

			let block = `<div id="${sec.id}" class="${pageBreakClass}">`;
			block += safe(sec?.content?.html || '');

			(sec.subsections || []).forEach((sub) => {
				if (sub.isVisible === false) return;
				if (sub.optional === true) return;
				block += `<div id="${sub.id}">${safe(sub?.content?.html || '')}</div>`;
			});

			block += '</div>';
			parts.push(block);
		});
	});

	return parts.join('\n');
}

export async function downloadDocumentPdfFromDashboard(documentId) {
	try {
		Toast.success('Preparing PDF download...');
		const res = await DocumentService.fetchDocumentById(documentId);
		const doc = res?.document || res;
		if (!doc) {
			Toast.error('Document not found.');
			return;
		}

		const documentType = doc.documentType?.name || 'Academic Paper';
		const contentHtml = stripExportOmitFromHtml(fileContentToHtml(doc.fileContent, documentType));
		const title = doc.title || 'document';

		const romanNumeralFrontPages = resolveRomanNumeralFrontPages(
			documentType,
			doc.fileContent,
			doc.finalFormatSettings?.romanNumeralFrontPages
		);

		const hasWatermark = shouldApplyExportWatermark(
			res?.exportEntitlements,
			res?.exportEntitlements?.planName
		);

		const result = await exportDocumentToPdf({
			contentHtml,
			title,
			documentType,
			config: getDefaultExportConfig(documentType),
			hasWatermark,
			romanNumeralFrontPages,
		});

		result.save(`${title}.pdf`);
		Toast.success('PDF downloaded.');
	} catch (error) {
		console.error('Dashboard PDF download failed:', error);
		Toast.error(error?.message || 'Failed to download PDF');
	}
}
